export const calculateTotal = (cols, dataList, totalObj, currencyType) => {
  const moneySign = currencyType === "USD" ? "$" : "￥";
  let totalData = {};
  cols
    .concat([
      { key: "reten1" },
      { key: "reten3" },
      { key: "reten7" },
      { key: "reten14" },
      { key: "reten30" },
      { key: "totalInstalls1" },
      { key: "totalInstalls3" },
      { key: "totalInstalls7" },
      { key: "totalInstalls14" },
      { key: "totalInstalls30" },
    ])
    .forEach((colItem) => {
      totalData[colItem.key] = dataList.reduce((total, tableLine) => {
        total += tableLine[colItem.key] ? parseFloat(tableLine[colItem.key]) : 0;
        return total;
      }, 0);
    });
  //预估倍数，历史总ROI,同期新增单价增幅,同期推广单价增幅，同期arpu增幅
  totalData.estimateTimes = totalObj.totalEstimateTimes;
  totalData.roiTotal = totalObj.totalRoi ? totalObj.totalRoi + "%" : '-';
  totalData.cresCostDiffer = totalObj.totalIncomeDiffer + "%";
  totalData.popCostDiffer = totalObj.totalPopuDiffer + "%";
  totalData.arpuDiffer = totalObj.totalArpuDiffer + "%";
  //自然量占比
  totalData.orgPercent = totalData.totalIncre
    ? ((totalData.orgIncre / totalData.totalIncre) * 100).toFixed(2) + "%"
    : "-";
  //活跃增比
  totalData.activePecent = totalData.totalIncre
    ? (totalData.activeUser / totalData.totalIncre).toFixed(2)
    : "-";
  //新增单价
  totalData.cresCost = totalData.totalIncre
    ? (totalData.popTotalUSD / totalData.totalIncre).toFixed(3)
    : "";
  //推广单价
  totalData.popCost = totalData.popuIncre
    ? (totalData.popTotalUSD / totalData.popuIncre).toFixed(3)
    : "";
  //变现活跃ARPU
  totalData.arpu = totalData.activeUser
    ? (totalData.incomeTotalUSD / totalData.activeUser).toFixed(3)
    : "";
  //估算变现价值
  totalData.estimateValue = totalData.arpu ? totalData.arpu * totalData.estimateTimes : 0;
  //新增ROI
  totalData.increRoi = totalData.cresCost
    ? ((totalData.estimateValue / totalData.cresCost) * 100).toFixed(2) + "%"
    : "";
  // 180ROI
  totalData.roi180 = totalData.cresCost && totalObj.ltv180
    ? ((totalObj.ltv180 / totalData.cresCost) * 100).toFixed(2) + "%"
    : "-";
  // 180Ltv
  totalData.ltv180 = totalObj.ltv180 ? moneySign + totalObj.ltv180 : '-'
  //推广ROI
  totalData.popuRoi = totalData.popCost
    ? ((totalData.estimateValue / totalData.popCost) * 100).toFixed(2) + "%"
    : "";
  //当前ROI
  totalData.toDayROI =
    (((totalData.incomeTotalUSD + totalData.payIncome) / totalData.popTotalUSD) * 100).toFixed(2) +
    "%";
  //内购收入占比
  totalData.payPerAdsRate =
    totalData.payIncome + totalData.incomeTotalUSD
      ? ((totalData.payIncome / (totalData.payIncome + totalData.incomeTotalUSD)) * 100).toFixed(
        2
      ) + "%"
      : "-";
  //活跃人均内购
  totalData.avgActivePayIncome = totalData.activeUser
    ? (totalData.payIncome / totalData.activeUser)
    : 0;
  //收入总计
  totalData.allTotalIncome =
    moneySign + (totalData.payIncome + totalData.incomeTotalUSD).toFixed(2);
  //当前变现ROI
  totalData.currentRoi =
    ((totalData.incomeTotalUSD / totalData.popTotalUSD) * 100).toFixed(2) + "%";
  //估算内购价值
  totalData.predictPayValue = totalData.avgActivePayIncome * totalData.estimateTimes;
  //估算用户价值
  totalData.predictUserValue = totalData.estimateValue + totalData.predictPayValue;
  //留存相关
  totalData.retenRate1 = totalData.totalInstalls1
    ? ((totalData.reten1 / totalData.totalInstalls1) * 100).toFixed(2) + "%"
    : "-";
  totalData.retenRate3 = totalData.totalInstalls3
    ? ((totalData.reten3 / totalData.totalInstalls3) * 100).toFixed(2) + "%"
    : "-";
  totalData.retenRate7 = totalData.totalInstalls7
    ? ((totalData.reten7 / totalData.totalInstalls7) * 100).toFixed(2) + "%"
    : "-";
  totalData.retenRate14 = totalData.totalInstalls14
    ? ((totalData.reten14 / totalData.totalInstalls14) * 100).toFixed(2) + "%"
    : "-";
  totalData.retenRate30 = totalData.totalInstalls30
    ? ((totalData.reten30 / totalData.totalInstalls30) * 100).toFixed(2) + "%"
    : "-";
  //处理符号
  totalData.estimateTimes = totalData.estimateTimes.toFixed(2);
  totalData.avgActivePayIncome = totalData.avgActivePayIncome
    ? moneySign + totalData.avgActivePayIncome.toFixed(2)
    : "-";
  totalData.predictPayValue = moneySign + totalData.predictPayValue.toFixed(2);
  totalData.predictUserValue = moneySign + totalData.predictUserValue.toFixed(2);
  totalData.cresCost = totalData.cresCost ? moneySign + totalData.cresCost : "-";
  totalData.popCost = totalData.popCost ? moneySign + totalData.popCost : "-";
  totalData.arpu = totalData.arpu ? moneySign + totalData.arpu : "-";
  totalData.estimateValue = totalData.estimateValue
    ? moneySign + totalData.estimateValue.toFixed(2)
    : "-";
  totalData.incomeTotalUSD = totalData.incomeTotalUSD
    ? moneySign + totalData.incomeTotalUSD.toFixed(2)
    : "-";
  totalData.popTotalUSD = moneySign + totalData.popTotalUSD.toFixed(2);
  totalData.payIncome = totalData.payIncome ? moneySign + totalData.payIncome.toFixed(2) : "-";

  return totalData;
};
